module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.refresh) ? _c('div', {
    staticClass: "order-container"
  }, [_c('div', {
    staticClass: "bd"
  }, [_c('gc-order-search-box', {
    on: {
      "updateSearchMap": _vm.handleFilter
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-group"
  }, [_c('span', {
    staticClass: "order-status",
    class: [_vm.tabIndex === _vm.emkt.MYORDER_TAB_WAITAUDIT ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(_vm.emkt.MYORDER_TAB_WAITAUDIT)
      }
    }
  }, [_vm._v("待审核")]), _vm._v(" "), (!_vm.isAfterSales) ? _c('span', {
    staticClass: "order-status",
    class: [_vm.tabIndex === _vm.emkt.MYORDER_TAB_WAITPAY ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(_vm.emkt.MYORDER_TAB_WAITPAY)
      }
    }
  }, [_vm._v("待下单")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "order-status",
    class: [_vm.tabIndex === _vm.emkt.MYORDER_TAB_EXECUTE ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(_vm.emkt.MYORDER_TAB_EXECUTE)
      }
    }
  }, [_vm._v("执行中")]), _vm._v(" "), _c('span', {
    staticClass: "order-status",
    class: [_vm.tabIndex === _vm.emkt.MYORDER_TAB_FINISHED ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(_vm.emkt.MYORDER_TAB_FINISHED)
      }
    }
  }, [_vm._v("已完成")]), _vm._v(" "), (!_vm.isAfterSales) ? _c('span', {
    staticClass: "order-status",
    class: [_vm.tabIndex === _vm.emkt.MYORDER_TAB_CANCELLED ? 'colorBlack' : 'colorGrey'],
    attrs: {
      "lines": undefined
    },
    on: {
      "click": function($event) {
        return _vm.changeTab(_vm.emkt.MYORDER_TAB_CANCELLED)
      }
    }
  }, [_vm._v("已取消")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tab-line-group"
  }, [_c('div', {
    staticClass: "under-line",
    style: ({
      'visibility': _vm.tabIndex === _vm.emkt.MYORDER_TAB_WAITAUDIT ? 'visible' : 'hidden'
    })
  }), _vm._v(" "), (!_vm.isAfterSales) ? _c('div', {
    staticClass: "under-line",
    style: ({
      'visibility': _vm.tabIndex === _vm.emkt.MYORDER_TAB_WAITPAY ? 'visible' : 'hidden'
    })
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "under-line",
    style: ({
      'visibility': _vm.tabIndex === _vm.emkt.MYORDER_TAB_EXECUTE ? 'visible' : 'hidden'
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "under-line",
    style: ({
      'visibility': _vm.tabIndex === _vm.emkt.MYORDER_TAB_FINISHED ? 'visible' : 'hidden'
    })
  }), _vm._v(" "), (!_vm.isAfterSales) ? _c('div', {
    staticClass: "under-line",
    style: ({
      'visibility': _vm.tabIndex === _vm.emkt.MYORDER_TAB_CANCELLED ? 'visible' : 'hidden'
    })
  }) : _vm._e()])], 1), _vm._v(" "), _c('div', {
    staticClass: "box",
    attrs: {
      "id": "myOrderList"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasCurrentDisplayOrders),
      expression: "hasCurrentDisplayOrders"
    }],
    staticClass: "order-list"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === _vm.emkt.MYORDER_TAB_WAITAUDIT),
      expression: "tabIndex===emkt.MYORDER_TAB_WAITAUDIT"
    }]
  }, [_c('order-list', {
    attrs: {
      "orderList": _vm.displayWaitAduitOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === _vm.emkt.MYORDER_TAB_WAITPAY),
      expression: "tabIndex===emkt.MYORDER_TAB_WAITPAY"
    }]
  }, [_c('order-list', {
    attrs: {
      "orderList": _vm.displayWaitPayOrders
    },
    on: {
      "cancelOrder": _vm.handleOrderCancel,
      "submitOrderToSign": _vm.handleOrderToSign,
      "submitOrderToCheckSignApprove": _vm.handleOrderToCheckSignApprove,
      "submitOrder": _vm.handleOrderSubmit
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === _vm.emkt.MYORDER_TAB_EXECUTE),
      expression: "tabIndex===emkt.MYORDER_TAB_EXECUTE"
    }]
  }, [_c('order-list', {
    attrs: {
      "orderList": _vm.displayExecutedOrders
    },
    on: {
      "cancelOrder": _vm.handleOrderCancel
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === _vm.emkt.MYORDER_TAB_FINISHED),
      expression: "tabIndex===emkt.MYORDER_TAB_FINISHED"
    }]
  }, [_c('order-list', {
    attrs: {
      "orderList": _vm.displayFinishedOrders
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabIndex === _vm.emkt.MYORDER_TAB_CANCELLED),
      expression: "tabIndex===emkt.MYORDER_TAB_CANCELLED"
    }]
  }, [_c('order-list', {
    attrs: {
      "orderList": _vm.displayCancledOrders
    }
  })], 1), _vm._v(" "), (_vm.fetchOrdersCompleted) ? _c('div', {
    staticClass: "research-font-color",
    staticStyle: {
      "text-align": "center",
      "height": "100px"
    }
  }, [(_vm.showLoadMore) ? _c('span', {
    on: {
      "click": _vm.loadMoreCurrentTabDisplayOrders
    }
  }, [_vm._v("加载更多...")]) : _c('p', {
    staticStyle: {
      "font-size": "12px",
      "margin-bottom": "30%"
    }
  }, [_vm._v("---我是有底线的---")])]) : _vm._e()]), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fetchOrdersCompleted && !_vm.hasCurrentDisplayOrders),
      expression: "fetchOrdersCompleted && !hasCurrentDisplayOrders"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "/static/img/订单空.png"
    }
  })])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45666f84","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/User/myOrders/Orders.vue
// module id = 1619
// module chunks = 8